/**
 * Where to send someone once they have signed in or registered.
 *
 * The booking wizard hands `?next=` to the auth screens so a customer who has
 * already chosen a branch, services and a slot comes back to the step they left
 * rather than to the account area. Only paths inside this storefront are ever
 * followed: an attacker-supplied `next` must not be able to bounce a
 * freshly-authenticated customer off to another origin.
 */
export function safeNext(next: string | null, slug: string, fallback = `/${slug}/account`): string {
  if (!next || !next.startsWith(`/${slug}/`)) return fallback
  // `//evil.com` is a protocol-relative URL, not a path, and it survives the
  // prefix test above only if the slug itself starts with a slash — but the
  // check costs nothing and states the intent.
  if (next.startsWith('//')) return fallback
  return next
}
